import {Component, inject, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {
  faChevronDown,
  faChevronUp,
  faClipboardUser,
  faEye,
  faTrashAlt,
  faPencilAlt,
  faPlus,
  faMagnifyingGlass
} from "@fortawesome/free-solid-svg-icons";
import {RoleService} from "../../../data-access/role.service";
import {AuthService} from "../../../../login/data-access/auth.service";
import {Dialog} from "@angular/cdk/dialog";
import {OrganizationsModel} from "../../../data-access/organizations.model";
import {SubjectsModel} from "../../../data-access/subjects.model";
import {UnitsModel} from "../../../data-access/units.model";
import {MatSnackBar} from "@angular/material/snack-bar";
import * as _ from "lodash";
import {UserManagementService} from "../../../data-access/user-management.service";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";
import {Subscription} from "rxjs";

export interface RoleInterface {
  name: string
  description: string
  createdate: Date
  userCount: number
  role_id: number
}
export interface RoleDetail {
  name: string
  role_id: string
  organizations: OrganizationsModel[]
  subjects: SubjectsModel[]
  units: UnitsModel[]
}
interface UserResponse {
  name: string,
  user_email: string,
  isSelected: boolean
}
@Component({
    selector: 'userRolesList',
    templateUrl: './userRolesList.html',
    styleUrls: ['../userRoleAddEdit/userRoleAddEdit.css', '../../../../exam/feature/list/list.component.css', 'userRolesList.css'],
    standalone: false
})
export class UserRolesListComponent implements OnInit {
  constructor(
    private router: Router,
    private roleService: RoleService,
    private _snackBar: MatSnackBar,
    private usersService: UserManagementService,
    private authService: AuthService,
  ) {}
  dialog = inject(Dialog);
  roleList: RoleInterface[] = []
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faClipboardUser = faClipboardUser;
  faEye = faEye;
  faTrashAlt = faTrashAlt;
  faPencilAlt = faPencilAlt;
  openAssignDialog = false;
  subjectList: SubjectsModel[] = [];
  addedSubjectList: SubjectsModel[] = [];
  unitList: UnitsModel[] = [];
  addedUnitList: UnitsModel[] = [];
  orgID: string = "";
  assignRoleDetails: RoleDetail | null = null;
  assigneeUserEmail = "";
  errorAssigneeUserEmail = false;
  errorUserEmailNotFound = false;
  faPlus = faPlus
  confirmDeleteDialog = false
  roleToDelete = -1
  roleToDeleteName = ""
  searchIconStyle = `color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem; margin-left: 0.5rem; flex-shrink: 1;`
  searchText = ''
  foundUsers: UserResponse[] = []
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement'
  }]
  canEditDescriptions = true;

  // TODO need to rewrite list privileges endpoint to include all the services that the user can call
  /*userPermissionSub: Subscription = this.authService.userDashboard$.subscribe((user) => {
    if(user.success) {
      for(let privilege of user.result) {
        console.log(privilege);
        if(privilege.service === "/roles/update/description") {
          this.canEditDescriptions = true;
        }
      }
    }
  })*/

  ngOnInit() {
    this.listAllUserRoles()
    this.roleService.listAllSubjectAndUnits().subscribe((response) => {
      if(response.success && response.result.length >= 1)
        this.orgID = response.result[0].organization_id
    })
  }

  listAllUserRoles() {
    this.roleService.listAllUserRoles().subscribe((response) => {
      if(response.success)
        this.roleList = response.items
      else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  addRole() {
    this.router.navigate(['dashboard/UserManagement/UserRoles/Add']);
  }

  editNavigation(role: number) {
    this.router.navigate(['dashboard/UserManagement/UserRoles/Edit'],{queryParams: {id: role}});
  }

  deleteRoleDialog(i: number) {
    this.confirmDeleteDialog = true
    this.roleToDelete = this.roleList[i].role_id
    this.roleToDeleteName = this.roleList[i].name
  }

  cancelRoleDeleteDialog() {
    this.confirmDeleteDialog = false
    this.roleToDelete = -1
  }

  confirmDeleteRole() {
    this.roleService.retireRole(this.roleToDelete).subscribe((response) => {
      if(response) {
        this._snackBar.open('Role successfully deleted', 'Dismiss', {duration: 3000})
        this.cancelRoleDeleteDialog()
        this.listAllUserRoles()
      } else {
        this._snackBar.open('Error deleting role', 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  assignDialog(role_id: number, role_name: string) {
    this.roleService.getRoleDetail(role_id.toString()).subscribe((response) => {
      if(response.success) {
        this.assignRoleDetails = {
          name: role_name,
          role_id: response.result.role_id,
          organizations: response.result.organizations,
          subjects: response.result.subjects,
          units: response.result.units
        }
        this.subjectList = response.result.subjects;
        this.unitList = response.result.units;
      }
    })
    this.openAssignDialog = true;
  }

  cancelAssignDialog() {
    this.openAssignDialog = false;
    this.subjectList = [];
    this.addedSubjectList = [];
    this.unitList = [];
    this.addedUnitList = [];
  }

  assignRoleClick() {
    let tempRoleID = "";
    if(this.assignRoleDetails?.role_id != null)
      tempRoleID = this.assignRoleDetails.role_id
    for(let user of this.foundUsers)
      if(user.isSelected)
        this.assigneeUserEmail = user.user_email
    const org: OrganizationsModel[] = [{
        organization_id: this.orgID
    }]
    // TODO add course_id
    this.roleService.assignOrRemoveRole(this.assigneeUserEmail, tempRoleID, this.addedSubjectList, this.addedUnitList, org, [], false).subscribe((response) => {
      if(response) {
        this.openAssignDialog = false;
        this._snackBar.open('Role successfully assigned', 'Dismiss', {duration: 3000})
      }
      else {
        this._snackBar.open('Error assigning role', 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }

  removeItemFromList(item: any, list: any[]) {
    return list.filter(e => e.name !== item.name);
  }

  viewAssignees(id: number) {
    this.router.navigate(['dashboard/UserManagement/UserRoles/Assignees'],{queryParams: {id: id}});
  }

  debounceSearch = _.debounce(() => {
    this.usersService.searchUsers(this.searchText, 0, 10).subscribe((response) => {
      if(response.success) {
        this.foundUsers = []
        for(let user of response.result.items) {
          this.foundUsers.push({
            name: user.display_name,
            user_email: user.email,
            isSelected: false
          })
        }
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
    })
  }, 500)

  selectUser(index: number) {
    for(let item of this.foundUsers) {
      item.isSelected = false
    }
    this.foundUsers[index].isSelected = true
  }

  submitDescription(role_id: number, description: string) {
    this.roleService.updateRoleDescription(role_id, description).subscribe((response) => {
      if(response.success) {

      } else {
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  enterDescriptionPress(element: HTMLElement) {
    element.blur()
  }

  protected readonly faMagnifyingGlass = faMagnifyingGlass;
}
